export default "__VITE_ASSET__BK4X$BV0__"